<div *ngIf="!!urlParams; else messageNoParams" class="wrapper flex-item">
    <img src="img/logo.png" id="logo" alt="Teleforum logo">
    <p>Attendere! Richiesta di aggiornamento token in corso ...</p>
    <div class="spinner">
        <div class="text-center">
            <div class="sk-circle">
              <div class="sk-circle1 sk-child"></div>
              <div class="sk-circle2 sk-child"></div>
              <div class="sk-circle3 sk-child"></div>
              <div class="sk-circle4 sk-child"></div>
              <div class="sk-circle5 sk-child"></div>
              <div class="sk-circle6 sk-child"></div>
              <div class="sk-circle7 sk-child"></div>
              <div class="sk-circle8 sk-child"></div>
              <div class="sk-circle9 sk-child"></div>
              <div class="sk-circle10 sk-child"></div>
              <div class="sk-circle11 sk-child"></div>
              <div class="sk-circle12 sk-child"></div>
            </div>
        </div>
    </div>
</div>

<ng-template #messageNoParams>
    <div class="wrapper flex-item" *ngIf="!auth_code">
        <img src="img/logo.png" id="logo" alt="Teleforum logo">
        <p>Parametri assenti o incorretti !</p>
    </div>
    <div class="wrapper flex-item" *ngIf="refresh_token && tokenNotified">
        <img src="img/logo.png" id="logo" alt="Teleforum logo">
        <p>Token aggiornato con successo!</p>
    </div>
    <div class="wrapper flex-item" *ngIf="tokenError">
        <img src="img/logo.png" id="logo" alt="Teleforum logo">
        <p>Token scaduto o non valido!</p>
    </div>
</ng-template>

